import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Daftar Penyesuaian Stok',
    title_form: 'Form Penyesuaian Stok',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Penyesuaian Stok',
        href: '/adm/logistic/penyesuaian-stok',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_stok',
    sortDesc: false,
    fields: [
      {
        key: 'code_stok',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'tgl_stok',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'gudang',
        label: 'Gudang',
        sortable: true,
      },
      {
        key: 'department',
        label: 'Department',
      },
      {
        key: 'remark',
        label: 'Keterangan',
      },
      {
        key: 'stok_status',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      tgl_stok: '',
      id_gudang: '',
      id_department: '',
      remark: '',
      items: [
        {
          id_stok: '',
          id_product: '',
          acc_stok: '',
          item_qty: '',
          id_alat_berat: '',
        },
      ],
    },
    journal: false,
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeStok(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetForm(state) {
    state.data = Object.assign({}, state.data, {
      form: {
        tgl_stok: '',
        id_gudang: '',
        id_department: '',
        remark: '',
        items: [
          {
            id_stok: '',
            id_product: '',
            acc_stok: '',
            item_qty: '',
            id_alat_berat: '',
          },
        ],
      },
    });
  },
};

export const actions = {
  async searchStok(context, params = null) {
    let result = await ApiGetRequest(`logistic/stok`, params);
    return !result.error ? result.data.object : [];
  },

  async getListStok({ commit, state }) {
    commit('changeStok', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/stok`, params);
    commit('changeStok', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getJournalStok({ commit }, payload = null) {
    commit('changeStok', {
      loading: true,
    });

    let result = await ApiGetRequest(`logistic/stok/${payload.id}/journal`);
    commit('changeStok', {
      loading: false,
    });

    if (!result.error) {
      commit('changeStok', {
        journal: result.data.object || [],
      });
    }

    return result.error ? false : true;
  },

  async getDetailStok({ commit, state }, payload = null) {
    commit('changeStok', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/stok/${payload.id}`);
    commit('changeStok', {
      loading: false,
    });

    if (!result.error) {
      commit('changeStok', {
        form: {
          ...data.form,
          ...result.data.object,
          tgl_stok: result.data.object.tgl_stok
            ? moment(result.data.object.tgl_stok).format('DD/MM/YYYY')
            : '',
        },
      });
    }

    return result.error ? false : true;
  },

  async createStok({ commit, state, dispatch }) {
    commit('changeStok', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/stok`, state.data.form);
    commit('changeStok', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateStok({ commit, state, dispatch }, payload = null) {
    commit('changeStok', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/stok/${payload.id}`,
      state.data.form
    );

    commit('changeStok', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteStok({ commit, dispatch }, payload = null) {
    commit('changeStok', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/stok/${payload.id}`);
    commit('changeStok', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
